export const iconFontAwesomeShoppingHeart = (
	<i className="fa-solid fa-heart"></i>
);
